<template>
<div>
  <v-card color="grey lighten-3 custom-font-regular" flat>
    <v-layout row pt-4>
      <v-flex xs1 offset-xs1><v-subheader>Filtrar por meses:</v-subheader></v-flex>
      <v-flex xs6>
        <SelectItems v-model="monthsSelected" :items="months" itemText="text" itemValue="value" label="Meses"
                     solo light></SelectItems>
      </v-flex>
      <v-flex xs1><v-btn icon @click="submit"><v-icon color="primary">search</v-icon></v-btn></v-flex>
      <v-flex xs3>
        <v-btn-toggle v-model="subColumnFilter" multiple>
          <v-btn flat>Realizado</v-btn>
          <v-btn flat>Presupuesto</v-btn>
          <v-btn flat>Desvío</v-btn>
        </v-btn-toggle>
      </v-flex>
    </v-layout>
    <v-layout row pt-2>
      <v-flex xs1 offset-xs1><v-subheader>Indicar desvío:</v-subheader></v-flex>
      <v-flex xs1>
        <v-text-field v-model="differenceValueFilter" class="mt-0" type="number" prefix="%" placeholder="0" solo light></v-text-field>
      </v-flex>
      <v-flex xs1>
        <v-btn class="mt-0 blue--text" @click="applyDifferenceFilter = !applyDifferenceFilter">
          {{ applyDifferenceFilter ? 'Ocultar' : 'Mostrar' }} filtro
        </v-btn>
      </v-flex>
    </v-layout>
  </v-card>
  <v-snackbar v-model="showErrorMessage" auto-height dark>
    <span class="red--text">Debe ingresar algún mes a filtrar</span>
    <v-btn icon @click="showErrorMessage = false"><v-icon>close</v-icon></v-btn>
  </v-snackbar>
  <div v-if="loading">
    <v-flex offset-xs5 pa-5>
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </div>
  <div v-else-if="started">
    <v-layout>
      <v-flex xs4>
        <v-data-table
          :headers="[{ text: title, sortable: false, align: 'center' }]"
          :items="['']"
          hide-actions
          no-data-text="No hay datos disponibles"
          class="custom-font-regular"
        >
          <template slot="items" slot-scope="{}">
            <td class="primary-table">
              <v-data-table
                :items="filteredRows"
                hide-actions
              >
                <template slot="headers">
                  <tr>
                    <th class="pa-0 ma-0 grey lighten-3">
                      <v-tooltip right class="ma-0 pa-0">
                        <v-btn icon small class="pa-0 ma-0 ml-1" slot="activator" @click="resetRowFilter">
                          <v-icon small>clear</v-icon>
                        </v-btn>
                        <span>Clear</span>
                      </v-tooltip>
                    </th>
                    <th class="text-xs-left grey lighten-3">
                      <v-btn @click="applyRowFilter" class="blue--text" small>
                        <v-icon small left color="primary">filter_list</v-icon>
                        Filtrar selección
                      </v-btn>
                      <v-btn @click="turnOffFilter" class="blue--text" small>
                        <v-icon small left color="primary">clear_all</v-icon>
                        Mostrar todo
                      </v-btn>
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td class="pa-0 ma-0 grey lighten-2 checkbox-td">
                    <v-checkbox v-model="filter[props.item.type][props.item.pk.toString()]" hide-details class="ml-2"></v-checkbox>
                  </td>
                  <td v-if="props.item.type === 'level_three'" class="item-header">{{ props.item.title }}</td>
                  <td v-else-if="props.item.type === 'level_two'" class="subtitle-header grey lighten-3">{{ props.item.title }}</td>
                  <td v-else-if="props.item.type === 'level_one'" class="title-header grey lighten-2">{{ props.item.title }}</td>
                  <td v-else-if="props.item.type === 'sub_total'" class="info lighten-1">{{ props.item.title }}</td>
                  <td v-else-if="props.item.type === 'total'" class="info">{{ props.item.title }}</td>
                  <td v-else-if="props.item.type === 'subtable'" class="text-xs-center grey lighten-1"><b>{{ props.item.title }}</b></td>
                  <td v-else-if="props.item.type === 'initial'" class="title-header text-xs-center initial yellow darken-1"><b>{{ props.item.title }}</b></td>
                  <td v-else class="title-header grey lighten-2">{{ props.item.title }}</td>
                </template>

                <template slot="no-data">
                  <div class="text-xs-center" v-if="loading">Cargando datos...</div>
                  <div class="text-xs-center" v-else>No hay datos disponibles</div>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs8>
        <v-data-table
          :headers="table.months"
          header-text="title"
          :items="['']"
          class="elevation-1"
          hide-actions
          no-data-text="No hay datos disponibles"
        >
          <template slot="items" slot-scope="{}">
            <td class="primary-table verticalLine" v-for="(value, i) in filteredValues" :key="i">
              <v-data-table
                :headers="table.subcolumnTitles"
                header-text="title"
                :items="value"
                hide-actions
                no-data-text="No hay datos disponibles"
              >
                <template slot="headers">
                  <tr>
                    <th v-if="subColumnFilter.includes(0)">Realizado</th>
                    <th v-if="subColumnFilter.includes(1)">Presupuesto</th>
                    <th v-if="subColumnFilter.includes(2)">Desvío</th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td v-if="subColumnFilter.includes(0)" :class="getValueStyle(props.item, props.item.values[0])">
                    {{ formatValue(props.item.values[0]) }}
                  </td>
                  <td v-if="subColumnFilter.includes(1)" :class="getValueStyle(props.item, props.item.values[1])">
                    {{ formatValue(props.item.values[1]) }}
                  </td>
                  <td v-if="subColumnFilter.includes(2)" :class="getValueStyle(props.item, props.item.values[2])">
                    {{ formatValue(props.item.values[2]) }}
                  </td>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</div>
</template>

<script>
import SelectItems from '../../../common/ui/SelectItems'

export default {
  props: {
    idTable: Number,
    idSecondTable: Number,
    title: String
  },

  components: {
    SelectItems
  },

  data () {
    return {
      table: {},
      loading: false,
      started: false,
      months: [
        { text: 'Enero', value: 1 },
        { text: 'Febrero', value: 2 },
        { text: 'Marzo', value: 3 },
        { text: 'Abril', value: 4 },
        { text: 'Mayo', value: 5 },
        { text: 'Junio', value: 6 },
        { text: 'Julio', value: 7 },
        { text: 'Agosto', value: 8 },
        { text: 'Septiembre', value: 9 },
        { text: 'Octubre', value: 10 },
        { text: 'Noviembre', value: 11 },
        { text: 'Diciembre', value: 12 }],
      monthsSelected: [],
      showErrorMessage: false,
      filter: this.getEmptyFilter(),
      isActiveRowFilter: false,
      subColumnFilter: [0, 1, 2],
      applyDifferenceFilter: false,
      differenceValueFilter: 50
    }
  },

  computed: {
    filteredRows () {
      if (!this.isActiveRowFilter) {
        return this.table.rows
      }
      return this.table.rows.filter(row => this.filter[row.type][row.pk])
    },
    filteredValues () {
      if (!this.isActiveRowFilter) {
        return this.table.values
      }
      return this.table.values.map(month => month.filter(row => this.filter[row.type][row.pk] === true))
    },
    isAnyCheckboxSelected () {
      return Object.values(this.filter).some(object => Object.values(object).some(value => value))
    }
  },

  methods: {
    formatHeader (list) {
      for (let element of list) {
        element.sortable = false
        element.align = 'center'
      }
    },
    formatData () {
      this.formatHeader(this.table.months)
      this.formatHeader(this.table.subcolumnTitles)
    },
    getFiltersParameters () {
      return `?months[]=${this.monthsSelected.join('&months[]=')}`
    },
    fetchSecondTable (filtersParameters) {
      this.axios
        .get(`/budget/table/${this.idSecondTable}` + filtersParameters)
        .then(response => {
          this.table.rows = this.table.rows.concat(response.data.rows)
          let values = []
          for (let i in this.table.values) {
            values.push(this.table.values[i].concat(response.data.values[i]))
          }
          this.table.values = values
        }).catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.started = false
          this.loading = false
        })
    },
    submit () {
      if (!this.monthsSelected.length) {
        this.showErrorMessage = true
        return
      }
      this.started = true
      this.loading = true
      let filtersParameters = this.getFiltersParameters()
      this.axios
        .get(`/budget/table/${this.idTable}` + filtersParameters)
        .then(response => {
          this.table = response.data
          if (this.idSecondTable) {
            this.fetchSecondTable(filtersParameters)
          }
          this.formatData()
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.started = false
          this.loading = false
        })
    },
    getEmptyFilter () {
      return {
        'initial': {},
        'subtable': {},
        'sub_total': {},
        'total': {},
        'level_one': {},
        'level_two': {},
        'level_three': {}
      }
    },
    turnOffFilter () {
      this.isActiveRowFilter = false
    },
    applyRowFilter () {
      if (this.isAnyCheckboxSelected) {
        this.isActiveRowFilter = true
      }
    },
    resetRowFilter () {
      this.filter = this.getEmptyFilter()
      this.isActiveRowFilter = false
    },
    getDifferencePercent (item) {
      let differenceValue = item.values[1]
      let budgetValue = item.values[2]
      if (isNaN(differenceValue) || isNaN(budgetValue) || differenceValue === 0) {
        return 0
      }
      return Math.abs(budgetValue / differenceValue * 100)
    },
    getStyleByType (rowType) {
      switch (rowType) {
        case 'total':
          return 'info'
        case 'sub_total':
          return 'info lighten-1'
        case 'level_two':
          return 'grey lighten-3'
        case 'level_one':
          return 'grey lighten-2'
        case 'subtable':
          return 'grey lighten-1'
        case 'initial':
          return 'yellow darken-1'
        default:
          return ''
      }
    },
    getValueStyle (item, rowValue) {
      let baseStyle = 'text-xs-center'
      let valueStyle = (rowValue === '') ? 'grey lighten-2' : ''
      let typeStyle = this.getStyleByType(item.type)
      if (this.applyDifferenceFilter && this.differenceValueFilter) {
        let differencePercent = this.getDifferencePercent(item)
        if (differencePercent >= this.differenceValueFilter) {
          typeStyle = 'red lighten-3'
        }
      }
      return [baseStyle, valueStyle, typeStyle]
    },
    formatValue (value) {
      if (isNaN(value)) return value
      let number = Math.trunc(value)
      return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    }
  }
}
</script>

<style scoped>
  .primary-table {
    padding: 0 0 0 0 !important;
    margin: 0 0 0 0 !important;
  }

  .verticalLine {
    border-left: 0.1em dotted gray;
  }

  .title-header {
    padding-left: 1.5em !important;
  }

  .subtitle-header {
    padding-left: 3em !important;
  }

  .item-header {
    padding-left: 4.5em !important;
  }
  .initial {
    border-top: 0.1em dotted gray;
  }
  table.v-table tbody td, table.v-table tbody th {
    height: 40px;
  }
  .checkbox-td {
    height: 1em;
    width: 1em;
  }
</style>
